import { render, staticRenderFns } from "./OrganizationList.vue?vue&type=template&id=20e61a3a&scoped=true&"
import script from "./OrganizationList.vue?vue&type=script&lang=js&"
export * from "./OrganizationList.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationList.vue?vue&type=style&index=0&id=20e61a3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e61a3a",
  null
  
)

export default component.exports